import React, {useEffect} from 'react';
import CardsContent from "./cards-content.jsx";
import StatusContent from "./status-content.jsx";
import PeriodContent from "./period-content.jsx";
import AttendancesContent from "./attendances-content.jsx";
import ChannelContent from "./channel-content.jsx";
import SourceContent from "./source-content.jsx";
import IdentificationContent from "./identification-content.jsx";
import PhonesContent from "./phones-content.jsx";
import HeatMap from "./heat-map.jsx";
import StreetContent from "./street-content.jsx";
import NeighborhoodContent from "./neighborhood-content.jsx";
import SectorContent from "./sector-content.jsx";
import NatureContent from "./nature-content.jsx";
import AttendanceListContent from "./attendance-list-content.jsx";
import NatureGroupContent from "./nature-group-content.jsx";

const ReportContent = ({data, collapsed}) => {

    return (
        <>

            <AttendanceListContent data={data}/>
            <CardsContent key={`cards-${collapsed}`} data={data}/>

            <div className="row">
                <StatusContent key={`status-${collapsed}`} data={data}/>
                <PeriodContent key={`period-${collapsed}`} data={data}/>
            </div>

            <div className="chart-divisor print-hide"></div>

                <AttendancesContent key={`attendances-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <ChannelContent key={`channel-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

            <div className="row">
                <SourceContent key={`source-${collapsed}`} data={data}/>
                <IdentificationContent key={`identification-${collapsed}`} data={data}/>
            </div>

            <div className="chart-divisor print-hide"></div>

                <PhonesContent key={`phones-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <HeatMap key={`heatMap-${collapsed}`} data={data}/>

                <StreetContent key={`street-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <NeighborhoodContent key={`neighborhood-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <SectorContent key={`sector-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <NatureContent key={`nature-${collapsed}`} data={data}/>

            <div className="chart-divisor print-hide"></div>

                <NatureGroupContent key={`nature-group-${collapsed}`} data={data}/>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;